import { message } from "./message";
import { packages } from "./packages";
import { whatsapp } from "./whatsapp";

export const communication = {
	title: "Mensagens",
	label: "Mensagens enviadas",
	export: "Exportar para Excel",
	new: "Nova mensagem",
	status: {
		sent: "enviado",
		canceled: "cancelado",
		notSent: "não enviado",
		scheduled: "agendado",
		error: "erro",
		delivered: "entregue",
		optout: "optout",
		sending: "enviando",
	},
	columns: {
		message: "Mensagem",
		place: "Casa",
		campaign: "Campanha",
		channel: "Canal",
		date: "Data e hora",
		status: "Status",
		impactedCustomers: "Clientes impactados",
	},
	at: "às",
	actions: {
		list: {
			sent: "Ver relatório de envio",
			schedule: {
				editAddressees: "Editar destinatários",
				editMessage: "Editar conteúdo da mensagem",
				cancelShipping: "Cancelar envio",
				hitchCampaign: "Atrelar envio à campanha",
			},
			canceled: "Ver relatório da mensagem",
		},
		cancelModal: {
			close: "Fechar",
			cancel: "Cancelar envio",
			text: "Você deseja cancelar o envio da mensagem agendada para ",
			clients: "clientes no dia",
			at: "às",
			confirm: "Ao cancelar o envio, seu saldo retornará à sua conta em algumas horas.",
		},
		campaignCategoryModal: {
			title: "Atrelar envio à campanha",
			tooltipMessage:
				"OPCIONAL: Atrele esse envio à uma campanha para facilitar a análise da performance de múltiplos envios juntos.",
			placeholder: "Selecione uma campanha",
			text: "Selecionar campanha",
			textButtonConfirm: "Confirmar seleção",
			successMessage: "Campanha atrelada a mensagem",
		},
	},
	message,
	packages,
	whatsapp,
	warningCard: {
		title: "Pagamento",
		label: "O valor de {{value}} será adicionado ao pagamento da cobrança mensal da Zig.",
	},
	modalChannel: {
		title: "Canal de comunicação",
		channel: {
			sms: {
				title: "SMS",
				description:
					"Selecione uma casa, filtre os clientes e envie mensagens de texto padrão",
			},
			whatsapp: {
				title: "WhatsApp",
				description:
					"Selecione uma casa, filtre os clientes e envie mensagens de WhatsApp",
			},
			email: {
				title: "E-mail",
				description:
					"Selecione uma casa, filtre os clientes e envie emails personalizados",
			},
		},
		tags: {
			new: "Novo",
			comingSoon: "Em breve",
		},
	},
	permissionDenied: "Nenhum local com permissão para gerenciar mensagens de WhatsApp",
};
